module.exports = __webpack_public_path__ + "media/five-coin.cf47fa7e.mp3";